<template>
  <div class="image-comp-container">
    <div v-if="background" 
         class="image-comp-single-1 position-relative"
    >
      <img :src="background">
    </div>
    <div v-if="foreground" 
         class="image-comp-single-2"
         :class="[background ? 'position-absolute' : 'position-relative']"
    >
      <img :src="foreground">
    </div>
    <div v-if="showLogo"
         class="image-comp-logo"
         :class="[background || foreground ? 'position-absolute' : 'position-relative']"
    >
      <img src="~assets/images/coche_logo.png" v-if="logoColor >= 0.5">
      <img src="~assets/images/coche_logo_white.png" v-else>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      background: {
        type: String,
        default: null
      },
      foreground: {
        type: String,
        default: null
      },
      showLogo: {
        type: Boolean,
        default: false
      },
      logoColor: {
        type: Number,
        default: 1
      }
    },

    data () {
      return {
      }
    },

    methods: {
    }
  }
</script>

<style lang="scss">
  .image-comp-container {
    position: relative;
    left: 0;
    top: 0;
  }

  .position-relative {
    position: relative;
  }

  .position-absolute {
    position: absolute;
  }

  .image-comp-single-1,
  .image-comp-single-2,
  .image-comp-logo {
    top: 0;
    left: 0;
  }
</style>


// WEBPACK FOOTER //
// ImageComposite.vue?8a587e90